import { SearchTabs, searchTabsEnum } from "../Tabs";
import { useSearchResults } from "./hooks/useSearchResults";
import { useTabs } from "./hooks/useTabs";
import { useMemo } from "react";
import { AllResults } from "../AllResults";
import { CategoryResults } from "../CategoryResults";
import "./SearchResultsView.scss";

interface ISearchResultsView {
  searchValue: string;
}

type TSearchTabs = Exclude<searchTabsEnum, searchTabsEnum.ALL>;

export const SearchResultsView = ({ searchValue }: ISearchResultsView) => {
  const { creators, niches, tags, tagsLoading, nichesLoading, creatorsLoading } = useSearchResults({ searchValue });
  const { tab, onTabChange } = useTabs({ initialTab: searchTabsEnum.ALL });

  const tabDataMapping = useMemo(
    () => ({
      [searchTabsEnum.CREATORS]: {
        data: creators,
        loading: creatorsLoading,
      },
      [searchTabsEnum.NICHES]: {
        data: niches,
        loading: nichesLoading,
      },
      [searchTabsEnum.TAGS]: {
        data: tags,
        loading: tagsLoading,
      },
    }),
    [creators, niches, tags, creatorsLoading, nichesLoading, tagsLoading]
  );

  const renderResults = useMemo(() => {
    if (tab === searchTabsEnum.ALL) {
      return (
        <AllResults
          searchValue={searchValue}
          creators={creators}
          niches={niches}
          tags={tags}
          isLoading={creatorsLoading || nichesLoading || tagsLoading}
        />
      );
    }

    const { data, loading } = tabDataMapping[tab as TSearchTabs];

    return (
      <CategoryResults
        searchValue={searchValue}
        data={data}
        loading={loading}
        activeTab={tab}
      />
    );
  }, [tab, searchValue, tabDataMapping]);

  return (
    <div className="searchResultsView">
      <SearchTabs activeTab={tab} onClick={onTabChange} />
      <div className="resultsBlock">
        {renderResults}
      </div>
    </div>
  );
};
